import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['slide', 'dot']
  static values = { interval: { type: Number, default: 3000 } }

  connect() {
    this.currentIndex = 0
    this.timer = setInterval(() => this.next(), this.intervalValue)
  }

  disconnect() {
    clearInterval(this.timer)
  }

  next() {
    this.goToIndex((this.currentIndex + 1) % this.slideTargets.length)
  }

  goTo(event) {
    this.resetTimer()
    this.goToIndex(parseInt(event.currentTarget.dataset.index))
  }

  goToIndex(index) {
    this.slideTargets.forEach((slide, i) => {
      if (i === index) {
        slide.classList.remove('tw-opacity-0', 'tw-pointer-events-none')
      } else {
        slide.classList.add('tw-opacity-0', 'tw-pointer-events-none')
      }
    })
    this.dotTargets.forEach((dot, i) => {
      if (i === index) {
        dot.classList.remove('tw-opacity-30')
      } else {
        dot.classList.add('tw-opacity-30')
      }
    })
    this.currentIndex = index
  }

  resetTimer() {
    clearInterval(this.timer)
    this.timer = setInterval(() => this.next(), this.intervalValue)
  }
}
